import { IProductsStockRepository } from "@/repository/warehouse/Products/ProductsStockRepository.types";
import Api from "@/repository/api";
import qs from "qs";
import {
    DataEntityStock,
    ProductsStock,
} from "@/entity/warehouse/Products/ProductsStock.types";
import { PaginationRequestType } from "@/entity/common/pagination.types";
//import { ResponseDataType } from "@/form/form.types";

export class ProductsStockRepository implements IProductsStockRepository {
    async fetchAll(data?: FormData): Promise<ProductsStock> {
        const response = await Api.get(`/products/stock`, {
            params: data,
            paramsSerializer: function paramsSerializer(params) {
                return new URLSearchParams(params).toString();
            },
        });
        return response.data as ProductsStock;
    }
    async fetchData(data: PaginationRequestType): Promise<DataEntityStock> {
        const response = await Api.get(`/products/stock`, {
            params: data,
            paramsSerializer: function paramsSerializer(params) {
                return qs.stringify(params, { arrayFormat: "repeat" });
            },
        });
        return response.data as DataEntityStock;
    }
}
